export default "__VITE_ASSET__DWsPoJBU__"